/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalSearchCommand
 */
export interface GlobalSearchCommand {
    /**
     * Texte recherché (min 2 caractères utiles après trim, sinon groups vide)
     * @type {string}
     * @memberof GlobalSearchCommand
     */
    searchString: string;
    /**
     * Types ciblés (client, contrat, devis, simulation, note, contratGroupe). Vide ou absent = tous. Sert au « voir plus » (re-appel ciblé sur un seul type).
     * 
     * @type {Array<string>}
     * @memberof GlobalSearchCommand
     */
    types?: Array<string>;
    /**
     * Nombre max d'items renvoyés par groupe
     * @type {number}
     * @memberof GlobalSearchCommand
     */
    limitPerType?: number;
}

/**
 * Check if a given object implements the GlobalSearchCommand interface.
 */
export function instanceOfGlobalSearchCommand(value: object): value is GlobalSearchCommand {
    if (!('searchString' in value) || value['searchString'] === undefined) return false;
    return true;
}

export function GlobalSearchCommandFromJSON(json: any): GlobalSearchCommand {
    return GlobalSearchCommandFromJSONTyped(json, false);
}

export function GlobalSearchCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'],
        'types': json['types'] == null ? undefined : json['types'],
        'limitPerType': json['limitPerType'] == null ? undefined : json['limitPerType'],
    };
}

export function GlobalSearchCommandToJSON(json: any): GlobalSearchCommand {
    return GlobalSearchCommandToJSONTyped(json, false);
}

export function GlobalSearchCommandToJSONTyped(value?: GlobalSearchCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'types': value['types'],
        'limitPerType': value['limitPerType'],
    };
}

